import React, { memo } from 'react'
import { IC_SAVING } from '../assets'
import { 
    Flex, 
    Image, 
    Text, 
} from '@chakra-ui/react'
import { format } from 'date-fns'
import { id } from 'date-fns/locale'

const Saving = ({ lastSync }) => {
    return (
        <Flex
            alignItems='center'
            gap='3px'
            width='full'
            justifyContent='end'
        >
            <Image 
                src={IC_SAVING} 
                width='16px' 
                height='16px' 
            />
            <Text
                fontSize='11px'
                fontWeight='500'
                color='#909094'
            >Terakhir disimpan pada {format(new Date(lastSync), 'dd MMMM yyyy, HH:mm', { locale: id })}</Text>
        </Flex>
    )
}

export default memo(Saving)